module.exports = __webpack_public_path__ + "static/media/movistar.1948c0ab.svg";